const NoDataPlaceholder = () => (
  <span
    className="text-xs text-gray-400 whitespace-nowrap m-auto"
    data-testid="no-data-placeholder"
  >
    Нет данных
  </span>
);

NoDataPlaceholder.displayName = "NoDataPlaceholder";
export default NoDataPlaceholder;
